import React from "react";

import TabButton from "@components/button/TabButton";
import styled from "@emotion/styled";
import useGenderStore from "@store/header/useGenderStore";

const TabWrapper = styled.div(() => ({
  width: "100%",
  display: "flex",
  gap: "1rem",
}));

const GenderTab = () => {
  const { gender, setGender } = useGenderStore();

  const handleChangeTab = (type: "men" | "women") => {
    if (type !== gender) {
      setGender(type);
    }
  };

  return (
    <TabWrapper>
      <TabButton
        title="남성"
        active={gender === "men"}
        onClick={() => handleChangeTab("men")}
      />
      <TabButton
        title="여성"
        active={gender === "women"}
        onClick={() => handleChangeTab("women")}
      />
    </TabWrapper>
  );
};

export default GenderTab;
